<template>
  <!-- Page length options -->
  <div class="card">
    <div>
      <div v-show="onload" class="content bg-white">
        <placeholder-content isLoad="true" />
      </div>
      <div v-if="!onload && !hasPermission">
        <access-denied></access-denied>
      </div>
      <div v-else-if="!onload && !hasComingSoon">
        <ComingSoon />
      </div>

      <div
        v-show="!onload && hasPermission && hasComingSoon"
        class="card-header bg-white header-elements-inline"
      >
        <h5 class="card-title">{{ $t("Inventory Report") }}</h5>
      </div>
      <div v-show="!onload && hasPermission && hasComingSoon" class="card-body">
        <div v-show="onload">
          <div class="bg-white">
            <placeholder-content isLoad="true" />
          </div>
        </div>

        <!-- <div class="d-flex align-items-center justify-content-start"> -->
        <div v-show="!onload">
          <div
            class="d-flex align-items-center justify-content-start mb-3 p-3 bg-light mt-n3 mx-n3"
          >
            <!-- product -->
            <div class="d-flex">
              <span class="d-flex mx-3 align-items-center">{{
                $t("Product")
              }}</span>
              <Select2
                v-model="showText"
                :settings="settingsProduct"
                style="min-width: 300px"
                @change="onValueChange"
              />
            </div>
            <button
              @click="openFilter"
              type="button"
              class="btn btn-outline-normal rounded-left-0 d-flex"
              data-toggle="modal"
              data-target="#filter"
            >
              <i class="fas fa-sliders-v mr-2 mt-1" />
              {{ $t("More Filters") }}
              <span v-if="countFilter > 0" class="badge badge-secondary ml-2">{{
                countFilter
              }}</span>
            </button>
            <!-- perpage -->
            <div class="dataTables_length ml-auto mb-0">
              <PerPage @per-page="setPerPage" />
            </div>
          </div>
        </div>

        <div v-if="!onload" class="d-flex d-flex flex-wrap">
          <div class="card mr-3">
            <div class="card-body" style=" width: 220px; ">
              <span
                class="rounded-circle badge badge-icon bg-primary position-absolute top-0 right-0 mt-3 mr-3"
                ><i style="font-size: 11px;" class="fa-solid fa-box"></i
              ></span>
              <h6 class="mb-0 font-weight-semibold">
                {{ $t("Quantity (Unit)") }}
              </h6>
              <h3 class="text-grey-800 font-weight-semibold my-1" >
                {{ totalQuantity | formatNumberDigit }}
              </h3>
            </div>
          </div>
          <div class="card mr-3">
            <div class="card-body" style=" width: 220px; ">
              <span
                class="rounded-circle badge badge-icon bg-primary position-absolute top-0 right-0 mt-3 mr-3"
                ><i class="fas fa-sack-dollar"></i
              ></span>
              <h6 class="mb-0 font-weight-semibold">{{ $t("Total Value") }}</h6>
              <h3 class="text-grey-800 font-weight-semibold my-1">
                {{ totalValue | formatNumber }}
              </h3>
            </div>
          </div>
        </div>

        <div class="card" v-show="!onload">
          <div
            :class="[
              'table-responsive mt-0 data-nowrap table-hover table-order'
            ]"
            id="table-order"
          >
            <div class="vuetable-wrapper datatable-scroll">
              <vuetable
                :class="[loadingTable,'overflow-x-auto']"
                ref="vuetable"
                :no-data-template="$t('No Data Available')"
                :fields="table.fields"
                data-path="data"
                pagination-path=""
                :api-mode="false"
                :data-manager="dataManager"
                @vuetable:loaded="vuetableLoaded"
                @vuetable:loading="vuetableLoading"
                @vuetable:pagination-data="onPaginationData"
              >

               <template slot="tableHeader">
                  <template>
                    <tr>
                      
                      <th colspan="1">{{ $t('Ch.') }}</th>
                      <th colspan="1">{{ $t('Image') }}</th>
                      <th colspan="1">{{ $t('Product Name') }}</th>
                      <th colspan="1">{{ $t('Product Type') }}</th>
                      <th colspan="1">{{ $t('Warehouse') }}</th>
                      <th colspan="1">{{ $t('Cost') }}</th>
                      <th colspan="1">{{ $t('Stock Status') }}</th>
                      <th colspan="1">{{ $t('Available QTY') }}</th>
                      <th colspan="1">{{ $t('Low Stock Alert') }}</th>
                      <th colspan="1">
                        {{ $t('Sold Last 12 Months') }}
                      </th>
                      <th colspan="1">{{ $t('Average Sold Per Month') }}
                        <a
                          style="color: #706f72"
                           v-tooltip:top="$t('Total QTY sold in 12 month divide 12')"
                        >
                          <i class="fas fa-info-circle" />
                        </a>
                      </th>
                      <th colspan="1">{{ $t('Stock In Month') }}
                        <a
                          style="color: #706f72"
                           v-tooltip:top="$t('Available QTY/Average Sold Per Month')"
                        >
                          <i class="fas fa-info-circle" />
                        </a>
                      </th>
                      <th colspan="1">{{ $t('Stock Value') }}
                        <a
                          style="color: #706f72"
                           v-tooltip:top="$t('Purchase Unit Cost* Available QTY')"
                        >
                          <i class="fas fa-info-circle" />
                        </a>
                      </th>
                    </tr>
                     
                  </template>
                </template>
                <!-- :sort-order="sortOrder" -->

                <div slot="ch" slot-scope="props">
                  <img
                    v-tooltip:top="getTooltip(props.rowData)"
                    :data-original-title="getTooltip(props.rowData)"
                    class="image_box rounded"
                    :src="[
                      props.rowData.channel_id
                        ? props.rowData.channel_logo
                        : $storeIndex.getImageGobalAssets('icon-gosell')
                    ]"
                    alt=""
                  />
                </div>
                <div slot="image" slot-scope="props">
                  <ProductImageComponent
                    :product-id="props.rowData.product_reference_id"
                    :product-image-url="props.rowData.image_url"
                  />
                </div>
                <div slot="product_name" slot-scope="props">
                  <router-link
                    v-if="props.rowData.product_type == 'linked'"
                    :to="{ name: 't.a.productlink', query: {productLinkId: props.rowData.product_reference_id}}"
                    target="_blank"
                  >
                    <ProductNameComponent
                      :product-name="props.rowData.product_name"
                      :product-sku="props.rowData.product_sku"
                    />
                  </router-link>
                  <router-link
                    v-else
                    :to="{ name: 't.a.products', query: {productId: props.rowData.product_reference_id}}"
                    target="_blank"
                  >
                    <ProductNameComponent
                      :product-name="props.rowData.product_name"
                      :product-sku="props.rowData.product_sku"
                    />
                  </router-link>

                  
                </div>
                <div
                  slot="stock_status"
                  slot-scope="props"
                >
                  <div
                    v-html="inventoryStockStatus(props.rowData.stock_status)"
                  />
                </div>
                <div
                  slot="balance"
                  slot-scope="props"
                >
                  <div :class="props.rowData.balance > 0 ? 'text-success' : 'text-danger'">
                    <i
                      class="fas fa-warehouse-alt px-1"
                    />
                    <span>{{ props.rowData.balance | formatNumberDigit }}</span>
                  </div>
                </div>
                <div
                  slot="warehouse_name"
                  slot-scope="props"
                >
                  <router-link
                    :to="{ name: 't.a.warehouse', query: {link: encodeLink(JSON.stringify({warehouseId: props.rowData.warehouse_id}))}}"
                    target="_blank"
                  >
                    <span
                      class="btn-link pointer mr-1 "
                    >{{ props.rowData.warehouse_name }}
                    </span>
                  </router-link>
                </div>


              </vuetable>
            </div>
            <div class="datatable-footer">
              <vuetable-pagination-info
                class="dataTables_info ml-3"
                ref="paginationInfo"
                :no-data-template="$t('No relevant data')"
                :info-template="
                  $t('Displaying {from} to {to} of {total} items')
                "
              ></vuetable-pagination-info>
              <div class="dataTables_paginate paging_simple_numbers mb-0 mr-2">
                <vuetable-pagination
                  ref="pagination"
                  pagination-path="pagination"
                  @vuetable-pagination:change-page="onChangePage"
                ></vuetable-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <FilterMore v-if="isFilter" @close="isFilter = false" />
  </div>
</template>

<script>
import Api from "@/services/endpoint/tenant.service";
import PerPage from "../PerPage.vue";
import Select2 from "v-select2-component";
import Vuetable from "vuetable-2";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import VuetablePaginationInfo from "@/plugins/vuetable-2/VuetablePaginationInfo";
import fields from "../assets/js/Inventory_fields.js";
import moment from "moment";
import { convertTimezone } from "@/common/tenancy/convertTimezone";
import numeral from "numeral";
import PlaceholderContent from "@/plugins/PlaceholderContent.vue";
import AccessDenied from "@/components/tenancy/admin/error-page/templates/AccessDenied.vue";
import SubscriptionExpired from "@/components/tenancy/admin/error-page/templates/SubscriptionExpired.vue";

import Cookies from "js-cookie";
import ComingSoon from "../../error-page/templates/ComingSoon.vue";
import FilterMore from "./FiltersMoreInventory.vue";
import ApiWms from "@/services/endpoint/wms.service";
import ProductImageComponent from '@/components/tenancy/center/ProductImageComponent.vue';
import ProductNameComponent from '@/components/tenancy/center/ProductNameComponent.vue';

export default {
  components: {
    PerPage,
    Select2,
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    PlaceholderContent,
    AccessDenied,
    SubscriptionExpired,
    ComingSoon,
    FilterMore,
    ProductImageComponent,
    ProductNameComponent
  },
  data() {
    var self = this;
    return {
      wmsPermission: JSON.parse(Cookies.get('wmsServicePermission')),
      countFilter: 0,
      isFilter: false,
      hasComingSoon: true,
      checkedCount: 0,
      table: {
        fields: fields
      },
      loadingTable: "",
      paramsQuery: {
        limit: 10,
        page: 1,
        product_id: "",
        warehouse_ids: "",
        product_type: "",
        stock_status: ""
      },
      query: {
        limit: 10,
        page: 1,
        product_id: "",
        warehouse_ids: "",
        product_type: "",
        stock_status: ""
      },
      showText: "",
      ProductTypeSetting: {
        minimumResultsForSearch: Infinity,
        placeholder: this.$t("Product Type") + ".."
      },
      loadProductType: false,
      onload: true,
      hasPermission: true,
      totalValue: 0,
      totalQuantity: 0,
      settingsProduct: {
        placeholder: this.$t("Select product") + "...",
        width: "300",
        ajax: {
          cache: true,
          delay: 250,
          url: ApiWms.AUTH.URL + ApiWms.URL.REPORT_GETPRODUCT,
          data: function(params) {
            var query = {
              search: params.term,
              status: "active",
              page: 1,
              limit: 10
            };
            if (self.paramsQuery.product_type) {
              query["type"] = self.paramsQuery.product_type;
            }
            return ApiWms.Signature.create($.param(query)).substring(1);
          },
          processResults: function(data) {
            let product = data.data;
            return {
              results: product
            };
          }
        },
        templateResult: this.templateProduct,
        templateSelection: this.templateCustomSelect,
        escapeMarkup: function(m) {
          return m;
        },
        allowClear: true
      },
      filtersMore: []
    };
  },
  computed: {},
  methods: {
    dataManager(sortOrder, pagination) {
      this.setParams();
    },
    onPaginationData(tablePagination) {
      this.$refs.paginationInfo.setPaginationData(tablePagination);
      this.$refs.pagination.setPaginationData(tablePagination);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    setPerPage(perPage) {
      this.paramsQuery.current_page = 1;
      this.$refs.vuetable.currentPage = 1;
      this.paramsQuery.limit = perPage;
      this.setParams();
    },
    vuetableLoaded() {
    },
    vuetableLoading() {},
    async setParams() {

      if(!this.wmsPermission.includes('report_inventory_view')) {
        this.onload = false;
        this.hasPermission = false;
        return;
      }
      
      try {
        this.onload = true;
        
        this.query.page = this.$refs.vuetable.currentPage;
        this.query.limit = this.paramsQuery.limit;
        this.query.product_id = this.paramsQuery.product_id;
        this.query.product_type = this.paramsQuery.product_type;

        if (this.paramsQuery.warehouse_ids) {
          this.query.warehouse_ids = this.paramsQuery.warehouse_ids.join(",");
        }
        if (this.paramsQuery.stock_status) {
          this.query.stock_status = this.paramsQuery.stock_status.join(",");
        }
        
        let queryString = "";
        if (this.paramsQuery) {
          queryString += "?" + $.param(this.query);
        }

        let response = await ApiWms.Report.getInventoryList(queryString);
        const from = (response.data.page - 1) * response.data.limit + 1; // เริ่มที่ 1 ของหน้า
        const to = Math.min(
          response.data.page * response.data.limit,
          response.data.total_rows
        ); // ค่าสิ้นสุดไม่เกินจำนวนทั้งหมด
        let meta = {
          current_page: response.data.page,
          from: from,
          last_page: response.data.total_pages,
          per_page: response.data.limit,
          to: to,
          total: response.data.total_rows
        };
        Object.assign(response.data, { meta: meta });
        
        // จำนวนขายใน 12 เดือน || Sold Last 12 Months 
        // เฉลี่ยต่อเดือน || Average Sold Per Month [Sold Last 12 Months/ 12]
        // พอขายสำหรับกี่เดือน || Stock In Month [Quantity/ Sold Per Moth] 
        // มูลค่าสินค้า || Stock Value [Product'Cost*Quantity]
        response.data.data.forEach(row => {
          let balance = row.balance ? row.balance : 0
          let cost = row.cost ? row.cost : 0

          let sold_last_12_months = row.sum_sale ? row.sum_sale : 0;
          let average_sold_per_month = Math.floor(sold_last_12_months / 12);
          let stock_in_month = Math.floor(balance / average_sold_per_month);
          let stock_value = Math.floor(balance * cost);
          
          if(stock_in_month == 'Infinity'){
            stock_in_month = 0
          }

          row.sold_last_12_months = sold_last_12_months;
          row.average_sold_per_month = average_sold_per_month ;
          row.stock_in_month = stock_in_month ;
          row.stock_value = stock_value;
        });
        
        const data = this.$storeIndex.mutations.vueTableFormatJson(response);
        this.$refs.vuetable.setData(data);

        let sumQuantity = response.data.optional_data.sum_quantity;
        let totalCost = response.data.optional_data.total_cost;

        this.totalValue = response.data.optional_data.total_value;
        this.totalQuantity = sumQuantity;
        this.filtersMore = response.data.optional_data;
        
        this.loadingTable = "";
        // this.hasPermission = false;
        this.onload = false;
      } catch (error) {
        this.hasComingSoon = false;
        this.onload = false;
        this.hasPermission = true;

        console.log(error, "error");
      }
    },
    setQuerystring(obj) {
      this.$router
        .push({
          query: Object.assign({}, this.$route.query, obj)
        })
        .catch(() => {});
    },
    noResults() {
      return this.$t("No Result Found");
    },
    templateProduct(e) {
      let option = "";
      if (e.text == "Searching…") {
        option = this.$t("Searching...");
      } else {
        let skuNew = e.sku == "" || e.sku == null ? "-" : e.sku;

        let imageChannel = "";
        if (e.channel_logo) {
          imageChannel = e.channel_logo;
        } else {
          imageChannel = e.integration
            ? e.integration.integration_type.logo
            : this.$storeIndex.getImageGobalAssets("icon-gosell");
        }

        let channelName = e.integration
          ? e.integration.name
          : this.$t("Manual Product");
        let tooltipChannel = e.integration
          ? e.integration.integration_type.name + "/" + e.integration.name
          : this.$t("Manual Product");
        let linkProduct =
          e.omni_link_id != null
            ? '<span class="mx-2"><span class="badge bg-teal mr-2">' +
              this.$t("Linked") +
              "</span></span>"
            : "";
        let selectedProduct =
          e.selected && e.omni_link_id == null
            ? '<span class="mx-2"><span class="badge bg-danger-400 mr-2">' +
              this.$t("Selected") +
              "</span></span>"
            : "";

        if (e.connected) {
          selectedProduct =
            '<span class="mx-2"><span class="badge bg-info-400 mr-2">' +
            this.$t("Connected") +
            "</span></span>";
        }

        let bgDisable =
          e.connected || e.disabled || e.selected ? "bg-disable" : "";

        var image =
          '<img class="thumb32 rounded mr-3" src="' +
          this.$storeIndex.getImageSrc("channel/none") +
          '">';
        if (this.$storeIndex.isset(() => e.images) && e.images.length > 0) {
          image =
            '<img class="thumb32 rounded mr-3" src="' +
            (this.$storeIndex.isset(() => e.images[0]) ? e.images[0] : "") +
            '">';
        }
        option =
          "<div class='d-flex align-items-center pd-6px " + bgDisable + "'>";
        option +=
          "<div class='item-image ml-1'>" +
          image +
          "</div><div class='item-content w-100'>";
        option +=
          "<div class='font-weight-semibold item-name' style='word-wrap: break-word;'>" +
          e.name +
          linkProduct +
          selectedProduct +
          "</div>";

        option +=
          "<span class='mr-2'>" + this.$t("SKU") + ": " + skuNew + "</span>";

        option +=
          "<div class='item-bottom row ml-0'><img data-toggle='" +
          tooltipChannel +
          "'data-placement='top' title='" +
          tooltipChannel +
          "' class='rounded pointer mr-2' width='20' height='20' src=' " +
          imageChannel +
          " ' alt=''>" +
          "<span class='mr-2'>" +
          channelName +
          "</span>" +
          "</div>";
        option += "</div>";
        option += "</div>";
      }
      return option;
    },
    templateCustomSelect: function(data) {
      if (!data.id) {
        return data.text || "Select Product...";
      }
      this.paramsQuery.product_id = data.id;
      return `<span>${data.name || data.text}</span>`;
    },
    onValueChange(value) {
      if (!value) {
        this.paramsQuery.product_id = "";
      }
      this.setParams();

    },
    openFilter() {
      this.isFilter = true;
      this.$nextTick(() => {
        this.isFilter = true;
      });
    },
    filterinfo(data) {
      this.paramsQuery = data;
      this.setParams();
    },
    getOnClickData(action, data, id) {
      return {
        action: action,
        data: data,
        id: id
      };
    },
    getTooltip(rowData) {
      let channelDetail = '';
      if (rowData.integration == null) {
        channelDetail = 'Manual Product';
      } else {
        channelDetail = rowData.channel_name + ' / ' + rowData.channel_name;
      }
      return channelDetail;
    },
    inventoryStockStatus: function (inventoryStatus) {

      let statusHtml = '<span class="badge bg-success-400"><i class="fas fa-check-circle"></i>' + this.$t('_Inventory.In Stock') + '</span>';
      switch (inventoryStatus) {
        case 'LOW_STOCK':
          statusHtml = '<span class="badge text-white" style="background:#FFA726"><i class="fas fa-triangle-exclamation"></i>' + this.$t('Low Stock') + '</span>';
          break;
        case 'IN_STOCK':
          statusHtml = '<span class="badge bg-success-400"><i class="fas fa-check-circle"></i>' + this.$t('_Inventory.In Stock') + '</span>';
          break;
        case 'OUT_OF_STOCK':
          statusHtml = '<span class="badge bg-danger-400"><i class="fas fa-ban"></i>' + this.$t('Out Of Stock') + '</span>';
          break;
        default:
          break;
      }
      return statusHtml;
    },
    encodeLink (data) {
      return btoa(data)
    },
  },
  async mounted() {
  },
  filters: {
    formatNumber: function(value) {
      return numeral(value).format("0,0.00");
    },
    formatNumberDigit: function(value) {
      return numeral(value).format("0,0");
    }
  }
};
</script>

<style scoped>
.product-search-n-1
  .select2-container--default
  .select2-selection--multiple
  .select2-search--inline
  .select2-search__field {
  width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/tenancy/admin/report/inventory/Inventory.vue